import type { RequestParams } from '@/shared/api';
import type { BrandItemListParams } from '../model/types';

export const BRAND_KEYS = {
  all: ['brand'] as const,
  list: (params?: RequestParams) => [...BRAND_KEYS.all, 'list', params] as const,
  detail: (id: number | string) => [...BRAND_KEYS.all, 'detail', id] as const,
  itemList: (params?: BrandItemListParams) => [...BRAND_KEYS.all, 'item-list', params] as const,
};
